//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/importP4/views/main/lan/en';
import newMigration from 'Modules/importP4/views/main/.components/newMigration/lan/en';
import exceptionDetails from 'Modules/importP4/views/main/.components/exceptionDetails/lan/en';

locales = {
    ...locales,
    ...main,
    ...newMigration,
    ...exceptionDetails,
};

export default locales;